var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo, useState } from 'react';
import { useAppDispatch } from '../../../../hooks';
import { setMatchState } from '../../../../store/match';
import { DeskPool } from '../../DeskPool';
import { startPlayerIntroduction, startPlayerVote } from '../../../../api';
import { useErrorHandler } from '../../../../hooks/useErrorHandler';
export function StartRound({ useCase }) {
    const { errorHandler } = useErrorHandler();
    const dispatch = useAppDispatch();
    const [selectedPlayer, setSelectedPlayer] = useState(null);
    const onGameButtonClick = () => __awaiter(this, void 0, void 0, function* () {
        console.log('onGameButtonClick');
        if (selectedPlayer === null) {
            return;
        }
        try {
            if (useCase === 'INTRODUCTION') {
                const result = yield startPlayerIntroduction(selectedPlayer);
                console.log('INTRODUCTION start', result);
                dispatch(setMatchState(result));
            }
            else {
                const result = yield startPlayerVote(selectedPlayer);
                console.log('VOTE start', result);
                dispatch(setMatchState(result));
            }
        }
        catch (err) {
            errorHandler(err);
            console.error('onGameButtonClick error', err.response);
        }
    });
    const gameButtonState = useMemo(() => ({
        text: 'Я - первый',
        visible: selectedPlayer !== null,
        onClick: onGameButtonClick,
    }), [selectedPlayer]);
    return (_jsx(DeskPool, { onPlayerClickAction: (playerId) => setSelectedPlayer(playerId), gameButtonState: gameButtonState }));
}
